import { render } from "./calendar-clock-icon.vue?vue&type=template&id=2e2d0e32"
const script = {}

import exportComponent from "/Users/lukemorell/Documents/Projects/THCP Booking/hearingcare/web/app/themes/leightons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__